import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/download.svg'


const _withScopeId = n => (_pushScopeId("data-v-1ef03a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-image" }
const _hoisted_2 = { class: "app-info" }
const _hoisted_3 = { class: "app-title mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "small-desc"
}
const _hoisted_5 = { class: "app-short-description mt-2" }
const _hoisted_6 = { class: "bottom-button" }
const _hoisted_7 = { class: "app-buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Install ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "btn-gradient btn-assets-card rounded-pill",
  disabled: ""
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-check" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Installed ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Expired ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "app-pricing"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "app",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('open')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.icon)
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.smallDesc)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, "Authorized by " + _toDisplayString(_ctx.smallDesc), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.description), 1),
      (_ctx.state)
        ? (_openBlock(), _createElementBlock("small", {
            key: 1,
            class: _normalizeClass(["state badge", _ctx.stateClass])
          }, _toDisplayString(_ctx.state), 3))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "badge bg-success"
        }, _toDisplayString(label), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.installed)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-gradient btn-assets-card rounded-pill",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('install')), ["stop","prevent"]))
            }, _hoisted_10))
          : (_ctx.installed && !_ctx.expired)
            ? (_openBlock(), _createElementBlock("button", _hoisted_11, _hoisted_14))
            : _createCommentVNode("", true),
        (_ctx.installed && _ctx.expired)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn-gradient btn-assets-card rounded-pill",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('install')), ["stop","prevent"]))
            }, _hoisted_17))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isBusinessUnitBilling)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.currencySymbol) + " " + _toDisplayString(_ctx.pricing.price/12) + " / month. Charged annually. ", 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_router_view)
  ]))
}